import { NestedApiResponse } from 'shared/api'


export enum PaymentMethodsNames {
  Blik = 'Blik',
  BlikOneClick = 'Blik 1-click',
  OnDelivery = 'Płatność kartą przy odbiorze'
}

export interface PaymentMethod {
  id: string
  name: PaymentMethodsNames
  code: string
}

export interface PaymentMethodsResponse {
  data: NestedApiResponse<PaymentMethod[] | []>
}

export interface GetPaymentLinkResponse {
  data: {
    link: string
  }
}

export interface BlikErrorType {
  response?: {
    data?: {
      paymentMethodName?: string
    }
  }
}

// Use union types for better type safety
//   export type EditOrderStatus = EditOrderProducts & EditOrderDelivery;

export enum PaymentCodes {
  ON_DELIVERY = 'on_delivery',
  BLIK = 'blik',
  BLIK_ONE_CLICK = 'blik_one_click',
  DPAY = 'dpay',
  PAYNOW = 'paynow'
}
